import { render, staticRenderFns } from "./ImprintStyle.vue?vue&type=template&id=3ea4ab76&"
import script from "./ImprintStyle.vue?vue&type=script&lang=js&"
export * from "./ImprintStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImprintStyle.vue"
export default component.exports